import { getShipDefinition, type PlayerRace, type ShipId } from '@kaeliux/shared';
import { getShipIcon } from '../utils/shipIcons';

/** Icon + count rows for a ship manifest — shared by `FlightLogDetailsModal` and `BattleReportPage`. */
export default function ShipManifestList({
    ships,
    race,
}: {
    ships: Partial<Record<ShipId, number>>;
    race: PlayerRace;
}) {
    const entries = (Object.entries(ships) as [string, number][]).filter(([, count]) => count > 0);
    if (entries.length === 0) {
        return <p className="text-content-muted text-sm">No ships.</p>;
    }
    return (
        <div className="flex flex-col gap-1.5">
            {entries.map(([shipId, count]) => {
                const id = Number(shipId) as ShipId;
                const def = getShipDefinition(race, id);
                return (
                    <div key={shipId} className="flex items-center gap-2 text-sm text-content-primary">
                        <img src={getShipIcon(race, id)} alt={def.name} className="w-6 h-6 object-contain shrink-0" />
                        <span>{count.toLocaleString()}× {def.name}</span>
                    </div>
                );
            })}
        </div>
    );
}
